import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import {
  CSS2DRenderer,
  CSS3DRenderer,
  OrbitControls,
  Water,
} from "three/addons";

export function useThree({ autoSize, position }) {
  const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath(process.env.VUE_APP_BASE + "draco/gltf/");
  const loader = new GLTFLoader();
  loader.setDRACOLoader(dracoLoader);

  const width = document.body.clientWidth;
  const height = document.body.clientHeight;
  let renderer = new THREE.WebGLRenderer({
    antialias: true,
  });
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(width, height);

  const cssRenderer = new CSS2DRenderer();
  cssRenderer.setSize(width, height);
  cssRenderer.domElement.style.top = "0";
  cssRenderer.domElement.style.position = "absolute";
  cssRenderer.domElement.style.pointerEvents = "none";

  const css3DRenderer = new CSS3DRenderer();
  css3DRenderer.setSize(width, height);
  css3DRenderer.domElement.style.top = "0";
  css3DRenderer.domElement.style.position = "absolute";
  css3DRenderer.domElement.style.pointerEvents = "none";

  let scene = new THREE.Scene();
  const textureLoader = new THREE.TextureLoader();
  const texture = textureLoader.load(
    process.env.VUE_APP_BASE + "models/sky.jpg",
    () => {
      texture.mapping = THREE.EquirectangularReflectionMapping;
      texture.colorSpace = THREE.SRGBColorSpace;
      scene.background = texture;
    }
  );

  let camera = new THREE.PerspectiveCamera(75, width / height, 1, 1000);
  const x = position ? position[0] : -59.70328374353009;
  const y = position ? position[1] : 146.25649344845982;
  const z = position ? position[2] : -124.37796988989662;
  camera.position.set(x, y, z);

  camera.lookAt(1110, 0, 2110);

  const light = new THREE.DirectionalLight(0xffffff, 3);
  light.position.set(1, 1, 1).normalize();
  scene.add(light);
  const ambientLight = new THREE.AmbientLight(0xffffff, 1);
  scene.add(ambientLight);

  let controls = new OrbitControls(camera, renderer.domElement);
  controls.maxDistance = 800;
  controls.target.set(
    -38.235557542198976,
    -10.091692931620278,
    -22.866813657955806
  );
  controls.update();
  let minPan = new THREE.Vector3(-700, -500, -500);
  let maxPan = new THREE.Vector3(700, 500, 500);
  let _v = new THREE.Vector3();
  controls.addEventListener("change", function () {
    _v.copy(controls.target);
    controls.target.clamp(minPan, maxPan);
    _v.sub(controls.target);
    camera.position.sub(_v);
  });
  controls.saveState();
  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();

  const waterGeometry = new THREE.PlaneGeometry(0.1, 0.1);

  let water = new Water(waterGeometry, {
    textureWidth: 512,
    textureHeight: 512,
    waterNormals: new THREE.TextureLoader().load(
      process.env.VUE_APP_BASE + "models/water.jpg",
      function (texture) {
        texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
      }
    ),
    sunDirection: new THREE.Vector3(),
    sunColor: 0xffffff,
    waterColor: 0x001e0f,
    distortionScale: 3.7,
    fog: scene.fog !== undefined,
  });
  water.material.name = "water";
  water.rotation.x = -Math.PI / 2;
  scene.add(water);
  return {
    renderer,
    loader,
    scene,
    camera,
    cssRenderer,
    css3DRenderer,
    controls,
    raycaster,
    mouse,
    water,
  };
}
